import Firebase from '../firebase';

export async function fetchLatLngWithCitie(city) {
  const API_URL = 'http://api.weatherstack.com/current?access_key=37f2daddfd647b171d3e0cdd092227e2&query=';
  return fetch(`${API_URL}${city}`)
    .then((res) => res.json());
}

export async function fetchLatLngWithCitieAndState(city, state) {
  const API_URL = 'http://api.weatherstack.com/current?access_key=37f2daddfd647b171d3e0cdd092227e2&query=';
  return fetch(`${API_URL}${city}-${state}`)
    .then((res) => res.json());
}

export async function fetchState() {
  const API_URL = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';
  return fetch(API_URL)
    .then((res) => res.json());
}

export async function fetchCitiesByIdState(idState) {
  const API_URL = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/';
  return fetch(`${API_URL}${idState}/municipios`)
    .then((res) => res.json());
}
export async function fetchCitiesByUf(uf) {
  const API_URL = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados/';
  return fetch(`${API_URL}${uf}/distritos`)
    .then((res) => res.json());
}

export async function fetchLocations(city, state) {
  const API_URL = 'https://geocode.search.hereapi.com/v1/geocode?q=';
  return fetch(`${API_URL}${city} - ${state}&apiKey=Ug7vp78CJPLSSRriNOQ2zineFGF07QZ0RafY5M2jY18`)
    .then((res) => res.json());
}

export async function fetchUserData(uid) {
  return Firebase.firestore().collection('users').doc(uid).get();
}

export async function fetchLocations2(city, state) {
  const API_URL = 'https://geocode.search.hereapi.com/v1/geocode?q=';
  const fetchResult = await fetch(`${API_URL}${city} - ${state}&apiKey=Ug7vp78CJPLSSRriNOQ2zineFGF07QZ0RafY5M2jY18`);
  const jsonResult = await fetchResult.json();
  const {
    address: { city: cidade, stateCode: estado },
    position: { lat: latitude, lng: longitude },
  } = jsonResult.items[0];
  return {
    cidade, estado, latitude, longitude,
  };
}
